(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('race', {
            parent: 'entity',
            url: '/race?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.race.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race/races.html',
                    controller: 'RaceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('race');
                    $translatePartialLoader.addPart('racerType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('race-detail', {
            parent: 'race',
            url: '/race/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.race.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/race/race-detail.html',
                    controller: 'RaceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('race');
                    $translatePartialLoader.addPart('racerType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Race', function($stateParams, Race) {
                    return Race.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'race',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('race-detail.edit', {
            parent: 'race-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race.new', {
            parent: 'race',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                date: null,
                                startDate: null,
                                finishDate: null,
                                type: null,
                                notes: null,
                                imageUrl: null,
                                audioFileUrl: null,
                                duration: null,
                                minimumDistance: null,
                                language: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('race');
                });
            }]
        })
        .state('race.edit', {
            parent: 'race',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-dialog.html',
                    controller: 'RaceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('race.delete', {
            parent: 'race',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/race/race-delete-dialog.html',
                    controller: 'RaceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Race', function(Race) {
                            return Race.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('race', null, { reload: 'race' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
